import { useMemo } from 'react'

const rtf = new Intl.RelativeTimeFormat('sv-SE', { numeric: 'always' })

export const useRelativeDate = (date: Date) => {
  return useMemo(() => {
    const now = new Date()
    const diff = date.getTime() - now.getTime()
    const years = Math.floor(Math.abs(diff / (1000 * 60 * 60 * 24 * 30.437 * 12)))
    const months = Math.floor(Math.abs(diff / (1000 * 60 * 60 * 24 * 30.437)))
    const days = Math.floor(Math.abs(diff / (1000 * 60 * 60 * 24)))
    const hours = Math.floor(Math.abs(diff / (1000 * 60 * 60)))
    const minutes = Math.floor(Math.abs(diff / (1000 * 60)))

    if (years > 0) {
      return rtf.format(-years, 'years')
    }

    if (months > 0) {
      return rtf.format(-months, 'months')
    }

    if (days > 0) {
      return rtf.format(-days, 'days')
    }

    if (hours > 0) {
      return rtf.format(-hours, 'hours')
    }

    return rtf.format(-minutes, 'minutes')
  }, [date])
}
